import gql from "graphql-tag";

export default gql`
	mutation supertechConfiramtion($supertech_users: [JSON!]!) {
		supertechConfirmation(supertechUsers: $supertech_users) {
			success
		}
	}
`;
